export const bus = {};
// export const bus = new window.Vue();
// window.busInstance = new window.Vue();

export default {};